import { TemplatePermessoPerGruppoOrganizzativo } from './template-permesso-gruppo-organizzativo';
import { TemplateProfilo } from './template-profilo';
import { TemplateUtenteProfilo } from './template-utente-profilo';
import { UtenteProfilo } from './utente-profilo';

export class UtenteProfiloFull {
  id: string;
  nome: string;
  cognome: string;
  codiceFiscale: string;
  username: string;
  email: string;
  pec: string;
  gruppiOperativi: TemplateProfilo[] = [];
  gruppiOrganizzativi: TemplateProfilo[] = [];
  gruppiVisibilita: TemplateProfilo[] = [];
  gruppiSpeciali: TemplateProfilo[] = [];
  ruoli: TemplateProfilo[] = [];
  permessi: TemplateProfilo[] = [];
  permessiPerGruppoOrganizzativo: TemplatePermessoPerGruppoOrganizzativo[] = [];

  constructor(utente: UtenteProfilo, templateUtenteProfilo: TemplateUtenteProfilo) {
    if (utente && ((!utente.pec) || (utente.pec && utente.pec.trim().length === 0))) {
      this.pec = null;
    } else {
      this.pec = utente.pec;
    }
    this.nome = utente.nome;
    this.cognome = utente.cognome;
    this.username = utente.username;
    this.id = utente.username;
    this.email = utente.email;
    this.codiceFiscale = utente.codiceFiscale;
    this.gruppiOperativi = templateUtenteProfilo.templateProfiloGruppiOperativi;
    this.gruppiOrganizzativi = templateUtenteProfilo.templateProfiloGruppiOrganizzativi;
    this.gruppiVisibilita = templateUtenteProfilo.templateProfiloGruppiVisibilita;
    this.gruppiSpeciali = templateUtenteProfilo.templateProfiloGruppiSpeciali;
    this.ruoli = templateUtenteProfilo.templateProfiloRuoli;
    this.permessi = templateUtenteProfilo.templateProfiloPermessi;
    this.permessiPerGruppoOrganizzativo = templateUtenteProfilo.permessiPerGruppoOrganizzativo;
  };
}

